module.exports = __webpack_public_path__ + "img/directory--icon.11f79fd4.svg";